// ============================================================================
// OUTSTANDING SERVICE — a party's position, bounded by the caller's scope (ADR-0042 §6).
// ============================================================================

import { get } from '../client/axiosClient';
import { outstandingEndpoints } from '../endpoints/accounts.endpoints';
import type { ApiResponse, ID, PartyOutstandingDto } from '../types';

class OutstandingService {
  /**
   * What a party owes and is owed, split into one business unit and every unit the user is
   * granted. The backend applies the scope bound, so no caller can widen it.
   *
   * @param businessUnitId The unit the near figure describes. Defaults to the session unit; pass
   *   it where the screen's work belongs to a different unit, so the figure and the list beneath
   *   it describe the same thing. A unit the user does not hold is refused, not silently zeroed.
   */
  async getForParty(partyId: ID, businessUnitId?: ID | null): Promise<PartyOutstandingDto> {
    const response = await get<ApiResponse<PartyOutstandingDto>>(
      outstandingEndpoints.party(partyId, businessUnitId));
    return response.data.data;
  }
}

export const outstandingService = new OutstandingService();
export default outstandingService;
